import cn from 'classnames';

import { AnimatedNumber } from 'ui/atoms/AnimatedNumber/AnimatedNumber';

import styles from './PriceProduct.module.scss';

const baseClass = 'gdb-price-product';

interface PriceProps {
  loading: boolean;
  currency: string;
  size?: 'lg' | 'sm';
  value?: number | string;
  valueExplanation?: string;
  className?: string;
}

export const PriceProduct = ({ loading, currency, value, valueExplanation, size, className }: PriceProps) => {
  return (
    <div className={cn(styles[`${baseClass}-wrapper`], className)}>
      <h3
        className={cn(
          `${styles[`${baseClass}-title`]}`,
          styles[`${baseClass}-${size}`],
          loading && styles[`${baseClass}-loading`],
        )}
      >
        {typeof value === 'number' ? (
          <AnimatedNumber value={value} prefix={currency} duration={250} />
        ) : (
          value || 'Custom'
        )}
      </h3>

      {valueExplanation && <span className={styles[`${baseClass}-frequency`]}>{valueExplanation}</span>}
    </div>
  );
};
